import { JetView } from 'webix-jet';
import FilterReport from 'views/reports/sportsPoolReport/filterReport';
import TableReport from 'views/reports/sportsPoolReport/tableReport';
import {devConfig, profile} from 'config/config';

export default class SportsPoolReportView extends JetView {
    /**
     * Configures the UI components for the view
     * @returns {Object} Configuration object for the view
     */
    config() {
        const _ = this.app.getService('locale')._;
        const theme = this.app.config.theme;

        const toolbar = {
            view: 'toolbar', // Main toolbar container
            css: 'highlighted_header header6', // Toolbar styling
            id: 'toolbar', // Toolbar ID
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown to change datatable page size
                    options: ['10','20','50','100','1000'],
                    width: 70,
                    on:{ onChange:function(){
                            $$('datatable').getPager().config.size = this.getValue()*1;
                            $$('datatable').refresh();
                            $$('datatable').scrollTo(100,0);
                        }}
                },
                {
                    view: 'pager', // Pager component to navigate through pages
                    id: 'pagerA',
                    template: '{common.first()}{common.prev()}&nbsp;{common.pages()}&nbsp;{common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch()
                },
                {
                    view: 'richselect', // Dropdown to select export type (Excel/PDF)
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'),
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' },   // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handles export option change
                            if (value == 1) {
                                // Export to Excel
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format;
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    { NameReport: ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + _('Reporte de Pollas - Resumido'),
                                        TypeReport: 'Excel' }
                                ]);
                                webix.toExcel(table, {
                                    filename: 'Virtualsoft - ' +
                                        new Date().toLocaleString('en-GB', {hour12: true})
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de Pollas - Resumido'),
                                    ignore: { detail: true },
                                });
                            } else {
                                if (value == 2) {
                                    // Export to PDF
                                    this.app.callEvent('export:data', [
                                        { NameReport: ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + _('Reporte de Pollas - Resumido'),
                                            TypeReport: 'PDF' }
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        filename: 'Virtualsoft - ' +
                                            new Date().toLocaleString('en-GB', {hour12: true})
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de Pollas - Resumido'),
                                        autowidth: true,
                                        ignore: { detail: true },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset selection after export
                        }.bind(this),
                    },
                },
            ]
        };

        const rightPanel = {
            view: "accordion", // Accordion container for detailed report
            id: "accordionDetail",
            multi: true,
            type: "wide",
            cols: [
                {
                    id: "dColl",
                    header: _("Reporte Detallado"), // Main panel header
                    collapsed: true,
                    body: {
                        rows: [
                            {
                                view: "accordion", // Nested accordion for filters
                                multi: true,
                                collapsed: true,
                                rows: [
                                    {
                                        id: "detailFilters",
                                        header: _("Filtros"), // Filters section
                                        body: {
                                            view: "form", // Form to hold filter fields
                                            id: "detailFilterForm",
                                            rows: [
                                                {
                                                    margin: 15,
                                                    css: "on-row",
                                                    cols: [
                                                        {
                                                            view:'text', // Text field for date range (readonly)
                                                            id:'Datepicker',
                                                            name:'Datepicker',
                                                            css:'reportrange',
                                                            readonly:true,
                                                            label:"<span class='webix_icon icon-calendar'></span>"+_('Rango de fechas'),
                                                            labelPosition:'top',
                                                            placeholder:_('Click para seleccionar ')
                                                        },
                                                        {
                                                            view:'datepicker', // Single date selector
                                                            id:'Date',
                                                            name:'Date',
                                                            stringResult:true,
                                                            minWidth:200,
                                                            label:"<span class='webix_icon icon-calendar'></span>"+_('Fecha'),
                                                            labelPosition:'top',
                                                            placeholder:_('Selecciona fecha'),
                                                            value: moment().format("YYYY-MM-DD"),
                                                            format:'%d %M %Y',
                                                            suggest:{ type:'calendar', body:{ maxDate:new Date() } }
                                                        },
                                                        {
                                                            view: "richselect", // Dropdown for state filter
                                                            id: "detailState",
                                                            name: "state",
                                                            label: _("Estado"),
                                                            labelPosition: "top",
                                                            placeholder: _("Selecciona Estado"),
                                                            options: [
                                                                { id: "ganador", value: _("Ganada") },
                                                                { id: "perdedor", value: _("Perdida") }
                                                            ]
                                                        },
                                                        {
                                                            view: "text", // Input for user ID filter
                                                            id: "detailUserId",
                                                            name: "userId",
                                                            label: _("ID de Usuario"),
                                                            placeholder: _("Ingresa ID de Usuario"),
                                                            labelPosition: "top"
                                                        }
                                                    ]
                                                },
                                                {
                                                    cols: [
                                                        {},
                                                        {
                                                            view: "button", // Clear button
                                                            value: _("Limpiar"),
                                                            width: 130,
                                                            click: () => {
                                                                $$("detailFilterForm").clear();
                                                            }
                                                        },
                                                        {
                                                            view: "button", // Consult/Apply filters button
                                                            value: _("Consultar"),
                                                            type: "form",
                                                            width: 130,
                                                            click: () => {
                                                                const filterdata = this.getRoot().getValues();
                                                                const values = $$("detailFilterForm").getValues();

                                                                if (profile.typeDate !== 2){
                                                                    delete filterdata['Date'];
                                                                } else {
                                                                    delete filterdata['Datepicker'];
                                                                }

                                                                this.app.callEvent("sportsPoolReportDetail:filter", [values]);
                                                                $$("detailFilters").collapse();
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                ]
                            },
                            {
                                view: "datatable", // Datatable to show detailed report
                                id: "datatableDetail",
                                css: "webix_header_border webix_data_border webix_footer_border",
                                scrollY: true,
                                footer: true,
                                pager: "pagerDetail",
                                columns: [
                                    { id: "userId", header: _("ID Usuario"), width: 120 },
                                    { id: "forecastId", header: _("ID Polla"), width: 120, footer: "Total:" },
                                    { id: "state", header: _("Estado"), width: 120 },
                                    { id: "betAmount", header: _("Monto Apostado"), width: 160, format: webix.i18n.priceFormat, footer: { content: "summColumn" } },
                                    { id: "awardsReceived", header: _("Premios Obtenidos"), width: 180, format: webix.i18n.priceFormat, footer: { content: "summColumn" } },
                                    { id: "dateRegistration", header: _("Fecha Primer Registro"), width: 180 },
                                    { id: "dateModified", header: _("Fecha Última Modificación"), width: 200 }
                                ],
                                on: {
                                    onBeforeLoad: function () { // Show loading overlay before data loads
                                        this.showOverlay("<div class='webix_overlay_loading'>Loading...</div>");
                                    },
                                    onAfterLoad: function () { // Handle empty or successful load
                                        this.hideOverlay();
                                        if (!this.count()) {
                                            this.showOverlay("<div class='no-data'>" + _("No hay datos") + "</div>");
                                        }
                                    }
                                }
                            },
                            {
                                view: "toolbar", // Toolbar below datatable for pagination and export
                                css: "highlighted_header header6",
                                id: "toolbarDetail",
                                paddingX: 5,
                                paddingY: 5,
                                height: 40,
                                cols: [
                                    {
                                        view: "select", // Dropdown to set page size
                                        id: "detailPageSize",
                                        options: ["10","20","50","100","1000"],
                                        width: 70,
                                        on:{
                                            onChange:function(){
                                                $$("pagerDetail").config.size = this.getValue()*1;
                                                $$("datatableDetail").refresh();
                                                $$("datatableDetail").scrollTo(100,0);
                                            }
                                        }
                                    },
                                    {
                                        view: "pager", // Pager component for datatableDetail
                                        id: "pagerDetail",
                                        template: "{common.first()}{common.prev()}&nbsp;{common.pages()}&nbsp;{common.next()}{common.last()}",
                                        autosize: false,
                                        height: 35,
                                        size: devConfig.getDefaultDataFetch()
                                    },
                                    {
                                        view: 'richselect', // Dropdown to export detailed report (Excel/PDF)
                                        name: 'ExportDetail',
                                        id: 'ExportDetail',
                                        width: 120,
                                        placeholder: _('Exportar'),
                                        options: [
                                            { id: '1', value: 'Excel' }, // Excel export option
                                            { id: '2', value: 'PDF' },   // PDF export option
                                        ],
                                        on: {
                                            onChange: function (value) {
                                                // Handle export option selection
                                                if (value == 1) {
                                                    // Excel export
                                                    var table = $$('datatableDetail');
                                                    for (var j = 0; j < table.config.columns.length; j++) {
                                                        if (table.config.columns[j].exportType) {
                                                            delete table.config.columns[j].format;
                                                        }
                                                    }
                                                    this.app.callEvent('export:detail', [
                                                        {
                                                            NameReport: ($$('datatableDetail').count() > 0 ? '' : _('No hay datos - ')) +
                                                                _('Reporte de Pollas - Detallado'),
                                                            TypeReport: 'Excel',
                                                        },
                                                    ]);
                                                    webix.toExcel(table, {
                                                        filename: 'Virtualsoft - ' +
                                                            new Date().toLocaleString('en-GB', {hour12: true})
                                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                                .replace(/[\/:]/g, '_')
                                                                .toUpperCase() +
                                                            ' - ' +
                                                            ($$('datatableDetail').count() > 0 ? '' : _('No hay datos - ')) +
                                                            _('Reporte de Pollas - Detallado'),
                                                    });
                                                } else {
                                                    if (value == 2) {
                                                        // PDF export
                                                        this.app.callEvent('export:detail', [
                                                            {
                                                                NameReport: ($$('datatableDetail').count() > 0 ? '' : _('No hay datos - ')) +
                                                                    _('Reporte de Pollas - Detallado'),
                                                                TypeReport: 'PDF',
                                                            },
                                                        ]);
                                                        webix.toPDF($$('datatableDetail'), {
                                                            filename: 'Virtualsoft - ' +
                                                                new Date().toLocaleString('en-GB', {hour12: true})
                                                                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                                    .replace(/[\/:]/g, '_')
                                                                    .toUpperCase() +
                                                                ' - ' +
                                                                ($$('datatableDetail').count() > 0 ? '' : _('No hay datos - ')) +
                                                                _('Reporte de Pollas - Detallado'),
                                                            autowidth: true,
                                                        });
                                                    }
                                                }
                                                $$('ExportDetail').setValue(''); // Reset selection after export
                                            }.bind(this),
                                        },
                                    },
                                ]
                            }
                        ]
                    }
                }
            ]
        };

        return {
            id:'a5',
            type:'clean',
            view:'form', // Main form container
            scroll:'y', // Enable vertical scrolling
            css:'scrolling',
            cols:[
                {
                    css:'int-left',
                    rows:[
                        {
                            view: 'toolbar', // Top toolbar
                            css: theme,
                            cols: [
                                {}, // Spacer
                                {
                                    view: 'label', // Title label
                                    label: _('Reporte de Pollas Deportivas'),
                                    align: "center",
                                    css: { "text-align": "center", "font-weight": "bold" },
                                    gravity: 2
                                },
                                {}, // Spacer
                                {
                                    id: 'button-search', // Search button container
                                    cols: [
                                        {
                                            view: 'icon', // Search icon button
                                            icon: 'wxi-search',
                                            width: 30,
                                            height: 30,
                                            click: () => { $$("filterPopup").show(); } // Show filter popup
                                        }
                                    ]
                                }
                            ]
                        },
                        FilterReport, // Component for filters
                        TableReport, // Component for datatable
                        toolbar // Reusable toolbar with pagination/export
                    ]
                },
                { id:'res', view:'resizer'}, // Resizer between panels
                rightPanel // Right panel with detailed report accordion
            ]
        };
    }

    /**
     * Initializes the view and fetches necessary data
     */
    init(){
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent("onAfterRender", ()=> devConfig.setDateModal(lang)); // Attach event to configure date modal after render

        webix.ready(function(){
            // Toggle visibility between Date and Datepicker depending on profile.typeDate
            if (profile.typeDate !== 2){
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                $$('Date').show();
                $$('Datepicker').hide();
            }
        });

        webix.ready(function(){
            // Adjust UI for small screens
            if (screen.width < 500 || screen.height < 500){
                $$("res").hide();
                $$("res2").hide();
                var childs = $$("toolbar").getChildViews();
                $$("toolbar").removeView(childs[2]);
                $$("pagerA").define("group",1);
            }
            // Hide search button for larger screens
            if (screen.width > 500 && screen.height > 500){
                $$("button-search").hide();
            }
        });
    }
}
